import React from 'react';

import getTableCell from './getTableCell';
import TableCell from '../../../Table/TableCell/TableCell';

const getTableCells = ({ columns, visibleColumns, data, shimmer, rowActions, index }) => {
  const items = columns.reduce((cells, column) => {
    if (visibleColumns === null || visibleColumns.includes(column.label)) {
      return [...cells, getTableCell(column, data, shimmer)];
    }
    return cells;
  }, []);

  if (rowActions) {
    const RowActions = rowActions;
    items.push(
      <TableCell key={`table-body-row-dropdown-${index}`} actions>
        <RowActions row={data} />
      </TableCell>,
    );
  }

  return items;
};

export default getTableCells;
